/** TODO: 디렉토리 이동 필요 (src/utils/interest-free-installment.ts -> src/utils/interest-free-installment.ts) */
import { getGroupData } from '../api/supabase/codeService';
import { getSiteConfig } from '../api/utils/api/siteConfigApi';
import { SITE_CONFIG_KEY } from '../constants/types/site-config-type';
import { CS_INFO_FALLBACK, toCsInfo } from '../hooks/useCsInfo';

const buildDefaultMessage = (contactPhone: string) => `[무이자 할부 안내]

카드사에서 제공하는 무이자할부는
최종 결제화면에서 확인 가능합니다.

* 무이자 12개월 이벤트 진행중!
- 영어교실 코스 등록 시 선착순 적용
- 고객센터로 신청해 주세요. ☎${contactPhone}`;

export const INTEREST_FREE_INSTALLMENT_DEFAULT = buildDefaultMessage(
  CS_INFO_FALLBACK.phone,
);

/**
 * 기본 안내 문구 (연락처는 사이트 설정 값, 조회 실패 시 폴백값 사용)
 */
const getDefaultMessage = async (): Promise<string> => {
  try {
    const configs = await getSiteConfig([SITE_CONFIG_KEY.CS_INFO]);
    return buildDefaultMessage(
      toCsInfo(configs[SITE_CONFIG_KEY.CS_INFO]).phone,
    );
  } catch (err) {
    console.error('연락처 설정 조회 실패', err);
    return INTEREST_FREE_INSTALLMENT_DEFAULT;
  }
};

const INTEREST_FREE_INSTALLMENT_KEY = 'INTEREST_FREE_INSTALLMENT';

/**
 * 텍스트의 빈 줄을 공백 문자로 대체하여 보존하는 함수
 */
const preserveEmptyLines = (text: string): string => {
  return text.replace(/\n\n/g, '\n\u00A0\n');
};

/**
 * supabase에서 무이자 할부 텍스트를 가져오는 함수
 * @returns 무이자 할부 텍스트
 */
export const getInterestFreeInstallmentMessage = async (): Promise<string> => {
  try {
    const res = await getGroupData(INTEREST_FREE_INSTALLMENT_KEY);
    const message = res[INTEREST_FREE_INSTALLMENT_KEY];

    // 데이터가 없거나 빈 문자열인 경우 기본값 사용
    if (!message || message.trim() === '') {
      console.warn('무이자 할부 정보가 비어있어 기본값을 사용합니다.');
      return preserveEmptyLines(await getDefaultMessage());
    }

    return preserveEmptyLines(message);
  } catch (error) {
    console.error('무이자 할부 정보를 가져오는데 실패했습니다:', error);
    return preserveEmptyLines(await getDefaultMessage());
  }
};
